import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import "../styles/market.css";
import { fetchAvgPrice, fetchLoginAvgPrice, fetchTerms, fetchTxDownloadPrice, fetchSourceList } from "../api/market";
import { Context } from "../pages/LoginMarket";
import {
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Button,
  Spinner,
} from "reactstrap";
import { DataWithColorSeriesTypes, DataPointTypes } from "../types";
// import { errornotify } from "./Message";
import moment from "moment";
import { useSelector } from "react-redux";
import { selectUtility } from "../store/utility/selector";
import { PriceComparisionChart } from "./Charts/PriceComparisionChart";
import UsageBtnGroup from "./UsageBtnGroup";
import { Typography } from "@mui/material";
import { selectLocation } from "../store/location/selector";
import { PriceBarChart } from "./Charts/PriceBarChart";
import DataTable from "react-data-table-component";
import { selectMyProvider } from "../store/myProvider/selector";
import Flatpickr from "react-flatpickr";
import { MultiSelectFilterDropdown } from "./Common/MultiSelectFilterDropdown";
// import AiSummary from "./AiSummary";

interface searchOptionObj {
  value: any;
  label: any;
}


const toChartsData = (inputData: any, outputData: any) => {
  if (inputData) {
    return inputData.map((item: any) => {
      if (item.date && +item.average_price !== 0) {
        return outputData.push({ x: item.date, y: +item.average_price });
      }
      return null;
    });
  } else {
    return (outputData = []);
  }
};

const MarketAvgRateTx = () => {
  const { provider, allProvider } = useContext(Context);
  const currentLocation = useSelector(selectLocation);
  const currentUtility = useSelector(selectUtility);
  const myProvider = useSelector(selectMyProvider);
  const isConstellation =
    String(myProvider?.provider_name || "").toLowerCase() === "constellation";

  const [selectedTerms, setSelectedTerms] = useState<string[]>([]);
  const [selectedSources, setSelectedSources] = useState<string[]>([]);
  const [termList, setTermList] = useState<string[]>([]);
  const [compareProvider12m, setCompareProvider12m] = useState<any>();
  const [compareProvider30d, setCompareProvider30d] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading12Month, setIsLoading12Month] = useState(false);
  const [isDownload, setIsDownload] = useState(false);

  const [filterValue, setFilterValue] = useState({
    price: 500,
    plan_type: "" as "" | number,
  });
  const [data, setData] = useState<DataWithColorSeriesTypes[]>([]);
  const [last12MonthData, setLast12MonthData] = useState<any>([]);
  const [myAveragePriceData, setMyAveragePriceData] = useState<any>([]);
  const [compare12MonthData, setCompare12MonthData] = useState<any[]>([]);

  const [providerList, setProviderList] = useState(["", provider.provider_id]);

  const [openTerms, setOpenTerms] = useState(false);
  const [openPlanType, setOpenPlanType] = useState(false);
  const [openSource, setOpenSource] = useState(false);
  const [sourceList, setSourceList] = useState<string[]>([]);

  const [searchProviderList, setSearchProviderList] = useState<
    Array<searchOptionObj>
  >([]);
  const [dataString, setDataString] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState(moment().subtract(30, "days").format("YYYY-MM-DD"));
  const [selectedEndDate, setSelectedEndDate] = useState(moment().format("YYYY-MM-DD"));

  const buildFilterParams = () => {
    const params: any = {
      terms: selectedTerms,
    };
    if (isConstellation && selectedSources.length) {
      params.sources = selectedSources;
    }
    if (isConstellation) {
      params.plan_type = filterValue.plan_type;
    }
    return params;
  };

  const getAvgPrice = async () => {
    setIsLoading(true);
    const filterParams = buildFilterParams();
    const params: any = {
      utility_id: currentUtility.utility_id,
      price: filterValue.price,
      date: `${selectedStartDate}&${selectedEndDate}`,
      ...filterParams,
    };
    const promise = providerList.map((item) => {
      if (+item) {
        return fetchLoginAvgPrice({ ...params, provider_id: +item });
      } else {
        return fetchLoginAvgPrice(params);
      }
    });
    const res = await Promise.all(promise);
    const resData: any = res.map((item, index) => {
      if (item.status === 1) {
        return item.response.average_price;
      } else {
        // errornotify(item.message || `Error trend[${index + 1}]`);
        return null;
      }
    });

    let avgData: DataPointTypes[] = [];
    let providerData: DataPointTypes[] = [];
    toChartsData(resData[0], avgData);
    toChartsData(resData[1], providerData);

    let newData = [
      {
        id: `${provider ? provider.provider_name : ""}`,
        data: providerData,
        color: "hsl(207,54.0%,46.9%)",
      },
      {
        id: "Market Price",
        data: avgData,
        color: "hsl(118,40.6%,48.8%)",
      },
    ];
    if (compareProvider30d) {
      try {
        const compareParams: any = {
          utility_id: currentUtility.utility_id,
          price: filterValue.price,
          date: `${selectedStartDate}&${selectedEndDate}`,
          provider_id: compareProvider30d.value,
          ...filterParams,
        };
        const compareRes = await fetchLoginAvgPrice(compareParams);
        
        if (compareRes.status === 1) {
          let compareData: DataPointTypes[] = [];
          toChartsData(compareRes.response.average_price, compareData);
          newData.unshift({
            id: compareProvider30d.label || "",
            data: compareData,
            color: "hsl(359,79.5%,49.8%)",
          });
        }
      } catch (error) {
        console.error("Failed to fetch compare provider data:", error);
      }
    }

    setData(newData);

    let _dataString = "";
    res.forEach((item) => {
      if (item.response) {
        const { response } = item;
        _dataString += `
            ##${
              response?.provider?.provider_name || "Market"
            } Average Rate Change
            ${JSON.stringify(response.average_price)}
        `;
      }
    });
    setDataString((prev) => prev + _dataString);

    setIsLoading(false);
  };

  const handleDownload = async () => {
    setIsDownload(true);
    try {
      const downloadParams: any = {
        utility_id: currentUtility.utility_id,
        price: filterValue.price,
        provider_id: myProvider?.provider_id,
        download: true,
        ...buildFilterParams(),
      };
      const res = await fetchTxDownloadPrice(downloadParams);
      const fileName = res.headers
      ?.get("content-disposition")
      ?.split("filename=")[1] || `MarketAvgRate_${currentLocation?.state_name || 'Unknown'}_${moment().format('YYYY-MM-DD')}.xlsx`;
      const data = await res.blob();
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsDownload(false);
    } catch (error) {
      console.error("Download failed:", error);
      setIsDownload(false);
    }
  };

  const getLast12MonthsData = async () => {
    setIsLoading12Month(true);
    const baseParams: any = {
      utility_id: currentUtility.utility_id,
      price: filterValue.price,
      provider_id: myProvider?.provider_id,
      ...buildFilterParams(),
    };
    if (isConstellation && compareProvider12m) {
      baseParams.compare_provider_id = compareProvider12m.value;
    }

    const res = await fetchAvgPrice(baseParams);
    if (res?.status === 1) {
      const { average_price, my_average_price, compare_average_price } = res?.response || {};

      setLast12MonthData(
        average_price
          ?.map((item: any) => ({
            date: moment(item.date, "MM/DD/YYYY").format("YYYY-MM-DD"),
            value: Number(item.average_price),
          }))
          ?.slice(-12) || []
      );

      setMyAveragePriceData(
        my_average_price
          ?.map((item: any) => ({
            date: moment(item.date, "MM/DD/YYYY").format("YYYY-MM-DD"),
            value: Number(item.average_price),
          }))
          ?.slice(-12) || []
      );

      if (!isConstellation || !compareProvider12m) {
        setCompare12MonthData([]);
      } else if (compare_average_price) {
        setCompare12MonthData(
          compare_average_price
            ?.map((item: any) => ({
              date: moment(item.date, "MM/DD/YYYY").format("YYYY-MM-DD"),
              value: Number(item.average_price),
            }))
            ?.slice(-12) || []
        );
      } else {
        setCompare12MonthData([]);
      }
    }
    setIsLoading12Month(false);
  };

  useEffect(() => {
    if (+provider.provider_id && allProvider.length && currentUtility) {
      setDataString("");
      getAvgPrice();
      getLast12MonthsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, providerList, currentUtility, isConstellation, selectedTerms, selectedSources]);

  useEffect(() => {
    if (+provider.provider_id && allProvider.length && currentUtility) {
      getAvgPrice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStartDate, selectedEndDate, providerList, currentUtility]);

  useEffect(() => {
    const getTerms = async () => {
      const res = await fetchTerms(currentUtility.utility_id);
      if (res.status !== 1) {
        return;
      }
      setTermList(
        res.response.map((item: string | number) => String(item))
      );
    };

    if (currentUtility) {
      getTerms();
    }
  }, [currentUtility]);

  useEffect(() => {
    if (!isConstellation) return;
    const loadSourceList = async () => {
      try {
        const res = await fetchSourceList();
        const list = res?.response || res || [];
        const options = Array.isArray(list)
          ? list.map((item: any) =>
              typeof item === "string"
                ? item
                : String(item.source ?? item)
            )
          : [];
        setSourceList(options);
      } catch (e) {
        console.error("Failed to load source list:", e);
      }
    };
    loadSourceList();
  }, [isConstellation]);

  useEffect(() => {
    if (+provider.provider_id && allProvider.length) {
      let searchList = allProvider.map((item: any) => {
        return { value: item.provider_id, label: item.provider_name };
      });
      setProviderList(["", provider.provider_id]);
      setSearchProviderList(searchList);
    } else {
      return;
    }
  }, [provider, allProvider]);

  useEffect(() => {
    if (+provider.provider_id && allProvider.length && currentUtility) {
      getAvgPrice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compareProvider30d]);

  useEffect(() => {
    if (isConstellation && +provider.provider_id && allProvider.length && currentUtility) {
      getLast12MonthsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compareProvider12m]);

  const changeUsage = (val: string) => {
    setFilterValue({
      ...filterValue,
      price: +val,
    });
  };

  const handleTermsChange = (terms: string[]) => {
    setSelectedTerms(terms);
  };

  const handleSourcesChange = (sources: string[]) => {
    setSelectedSources(sources);
  };

  const changePlanType = (val: "" | number) => {
    setFilterValue({
      ...filterValue,
      plan_type: val,
    });
  };

  const compareWith12m = (obj: any) => {
    setCompareProvider12m(obj);
  };
  const compareWith30d = (obj: any) => {
    setCompareProvider30d(obj);
  };

  const handleStartDateChange = (date: any) => {
    const newStartDate = moment(date).format("YYYY-MM-DD");
    setSelectedStartDate(newStartDate);
    
    const maxEndDate = moment(newStartDate).add(30, "days").format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    let newEndDate = selectedEndDate;
    if (moment(selectedEndDate).isAfter(maxEndDate)|| moment(newStartDate).isAfter(selectedEndDate)) {
      newEndDate = moment(maxEndDate).isAfter(today) ? today : maxEndDate;
      setSelectedEndDate(maxEndDate);
    }
  };

  const handleEndDateChange = (date: any) => {
    const newEndDate = moment(date).format("YYYY-MM-DD");
    
    const minStartDate = moment(newEndDate).subtract(30, "days").format("YYYY-MM-DD");
    let newStartDate = selectedStartDate;
    if (moment(selectedStartDate).isBefore(minStartDate)) {
      newStartDate = minStartDate;
      setSelectedStartDate(minStartDate);
    }
    
    setSelectedEndDate(newEndDate);
  };

  return (
    <Card style={{ minHeight: "600px" }}>
      <CardHeader className="align-items-center justify-content-between d-flex">
        <div>
          <h4 className="card-title mb-0 flex-grow-1">All In-Market Plans</h4>
          {currentLocation && currentUtility && (
            <Typography
              variant="subtitle2"
              className="text-muted"
            >{`${currentLocation.state_name} - ${currentUtility.utility_name}`}</Typography>
          )}
        </div>
        <div className="flex-shrink-0">
          {!isDownload ? (
            <Button
              color="secondary"
              onClick={handleDownload}
              className="btn-label"
            >
              <i className="bx bx-download label-icon align-middle fs-17 me-2"></i>
              <span>Download</span>
            </Button>
          ) : (
            <Button color="secondary" className="btn-load" outline>
              <span className="d-flex align-items-center">
                <Spinner size="sm" className="flex-shrink-0">
                  {" "}
                  Loading...{" "}
                </Spinner>
                <span className="flex-grow-1 ms-2">Loading...</span>
              </span>
            </Button>
          )}
        </div>
      </CardHeader>
      {/* <AiSummary data={dataString} /> */}
      <CardBody>
        <React.Fragment>
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <UsageBtnGroup
              onChangeValue={(val: string) => changeUsage(val)}
              isLoading={isLoading}
            />
            <MultiSelectFilterDropdown
              isOpen={openTerms}
              toggle={() => setOpenTerms(!openTerms)}
              options={termList}
              selected={selectedTerms}
              onChange={handleTermsChange}
              allLabel="All Terms"
              formatOption={(value) => `${value} Month`}
              width={120}
              requireConfirm
            />
            {isConstellation && (
              <>
                <Dropdown
                  isOpen={openPlanType}
                  toggle={() => setOpenPlanType(!openPlanType)}
                >
                  <DropdownToggle tag="button" className="btn btn-light">
                    {filterValue.plan_type === 1
                      ? "Usage Bill Credit"
                      : filterValue.plan_type === 3
                      ? "Flat Rate"
                      : filterValue.plan_type === 4
                      ? "Base Fee Plans"
                      : "All Plan Types"}{" "}
                    <i className="mdi mdi-chevron-down"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => changePlanType("")}>
                      All Plan Types
                    </DropdownItem>
                    <DropdownItem onClick={() => changePlanType(1)}>
                      Usage Bill Credit
                    </DropdownItem>
                    <DropdownItem onClick={() => changePlanType(3)}>
                      Flat Rate
                    </DropdownItem>
                    <DropdownItem onClick={() => changePlanType(4)}>
                      Base Fee Plans
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <MultiSelectFilterDropdown
                  isOpen={openSource}
                  toggle={() => setOpenSource(!openSource)}
                  options={sourceList}
                  selected={selectedSources}
                  onChange={handleSourcesChange}
                  allLabel="All Sources"
                  width={170}
                  className="text-uppercase"
                  requireConfirm
                />
              </>
            )}
          </div>

          {isConstellation && (
            <div style={{ width: "80%", marginTop: "10px" }}>
              <Label
                htmlFor="compare-12m"
                className="form-label text-muted mb-1"
                style={{ fontWeight: "400" }}
              >
                Compare with
              </Label>
              <div style={{ width: "240px" }}>
                <Select
                  value={compareProvider12m}
                  isClearable
                  onChange={(e) => compareWith12m(e)}
                  options={searchProviderList}
                  placeholder="Select competitor..."
                />
              </div>
            </div>
          )}
          <PriceBarChart
            title="Market Average Rate (Last 12 months)"
            data={last12MonthData}
            myAveragePriceData={myAveragePriceData}
            providerName={myProvider?.provider_name || "My Average"}
            compareAveragePriceData={isConstellation ? compare12MonthData : []}
            compareProviderName={isConstellation ? compareProvider12m?.label : undefined}
            isLoading={isLoading12Month}
          />

          <div style={{ display: "flex", gap: "20px", alignItems: "flex-end", marginTop: "24px", flexWrap: "wrap" }}>
          <div>
              <Label
                htmlFor="compare-30d"
                className="form-label text-muted mb-1"
                style={{ fontWeight: "400" }}
              >
                Compare with
              </Label>
              <div style={{ width: "240px" }}>
                <Select
                  value={compareProvider30d}
                  isClearable
                  onChange={(e) => compareWith30d(e)}
                  options={searchProviderList}
                  placeholder="Select competitor..."
                />
              </div>
            </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <Label
                  htmlFor="start-date-2"
                  className="form-label text-muted mb-0"
                  style={{ fontWeight: "400" }}
                >
                  Start Date
                </Label>
                <Flatpickr
                  className="form-control"
                  value={selectedStartDate}
                  options={{
                    dateFormat: "Y-m-d",
                    maxDate: moment().format("YYYY-MM-DD"),
                    allowInput: true,
                  }}
                  disabled={isLoading}
                  onChange={([newValue]: any) => handleStartDateChange(newValue)}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <Label
                  htmlFor="end-date-2"
                  className="form-label text-muted mb-0"
                  style={{ fontWeight: "400" }}
                >
                  End Date
                </Label>
                <Flatpickr
                  className="form-control"
                  value={selectedEndDate}
                  options={{
                    dateFormat: "Y-m-d",
                    maxDate: moment.min(
                      moment(selectedStartDate).add(30, "days"),
                      moment()
                    ).toDate(),
                    allowInput: true,
                  }}
                  disabled={isLoading}
                  onChange={([newValue]: any) => handleEndDateChange(newValue)}
                />
            </div>
          </div>
          <PriceComparisionChart
            title="Market Average Rate"
            data={data}
            isLoading={isLoading}
          />
          {!isLoading && <TrendTable data={data} />}
        </React.Fragment>
      </CardBody>
    </Card>
  );
};

const TrendTable = ({ data }: { data: any }) => {
  const formatTableData = (data: any) => {
    return data
      .map((item: any) => {
        if (item.data && item.data.length > 0) {
          const formatted: any = { id: item.id };
          item.data.forEach((entry: any) => {
            formatted[entry.x] = entry.y.toString();
          });
          return formatted;
        }
        return null;
      })
      .filter((item: any) => item !== null);
  };

  const tableData = formatTableData(data) || [];

  const frozenColumns = [
    {
      name: <span className="font-weight-bold fs-14">Rate Type</span>,
      selector: (row: any) => row.id,
    },
  ];

  const scrollableColumns = Object.keys(tableData[0] || {})
    .filter((key) => key !== "id")
    .map((dateKey) => ({
      name: dateKey,
      selector: (row: any) => `${Number(row[dateKey]).toFixed(2)}¢`,
    }));

  if (tableData.length === 0) return null;

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#F2F2F2",
      },
    },
  };
  return (
    <div className="combined-table">
      <div className="fronzen-table">
        <DataTable
          columns={frozenColumns}
          data={tableData}
          paginationPerPage={10}
          customStyles={{
            cells: { style: { backgroundColor: "#fafafa" } },
            ...customStyles,
          }}
          pagination={false}
        />
      </div>
      <div className="scrollable-table">
        <DataTable
          columns={scrollableColumns}
          data={tableData}
          paginationPerPage={10}
          customStyles={customStyles}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default MarketAvgRateTx;
